import Vue from 'vue'
import Vuex from 'vuex'

//= modules
import freeBoard from '@/modules/free-board'
import freeBoardDetails from '@/modules/freeboard-details'
import user from '@/modules/user'
import userWallet from '@/modules/userWallet'
import userMemo from '@/modules/userMemo'
import userReferral from '@/modules/userReferrals'
import testUser from '@/modules/test-user'
import transfer from '@/modules/transfer'
import transaction from '@/modules/transaction'
import bank from '@/modules/bank'
import game from '@/modules/game'
import match from '@/modules/match'
import league from '@/modules/league'
import country from '@/modules/country'
import team from '@/modules/team'
import matchGame from '@/modules/match-game'
import depositAccount from '@/modules/deposit-account'
import code from '@/modules/code'
import agent from '@/modules/agent'
import agentWallet from '@/modules/agentWallet'
import agentMemo from '@/modules/agentMemo'
import admin from '@/modules/admin'
import adminw from '@/modules/adminw'
import adminLogs from '@/modules/admin-logs'
import betHistory from '@/modules/bet-history'
import logins from '@/modules/logins'
import vip from '@/modules/vip'
import level from '@/modules/level'
import config from '@/modules/config'
import providerMatch from '@/modules/provider-match'
import notice from '@/modules/notice'
import faq from '@/modules/faq'
import support from '@/modules/support'
import events from '@/modules/events'
import meta from '@/modules/meta'
import domain from '@/modules/domain'
import ip from '@/modules/ip'
import points from '@/modules/points'
import settingsMenu from '@/modules/settingsMenu'
import settingsMarquee from '@/modules/settingsMarquee'
import settingsHome from '@/modules/settingsHome'
import settingsPoints from '@/modules/settingsPoints'
import superAdminLogs from '@/modules/superAdminLogs'
import settings from '@/modules/settings'
import importCSV from '@/modules/import'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    userWallet,
    userMemo,
    userReferral,
    'test-user': testUser,
    transfer,
    transaction,
    bank,
    freeBoard,
    'freeboard-details': freeBoardDetails,
    game,
    match,
    league,
    country,
    team,
    code,
    agent,
    agentWallet,
    agentMemo,
    admin,
    'admin-logs': adminLogs,
    logins,
    'match-game': matchGame,
    'deposit-account': depositAccount,
    'bet-history': betHistory,
    vip,
    level,
    config,
    providerMatch,
    notice,
    faq,
    support,
    events,
    meta,
    domain,
    ip,
    points,
    'settings-menu': settingsMenu,
    'settings-marquee': settingsMarquee,
    'settings-home': settingsHome,
    'settings-points': settingsPoints,
    'superadmin-logs': superAdminLogs,
    settings: settings,
    'adminw': adminw,

    'import-csv': importCSV
  }
})
